import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Homepage from './Pages/Homepage';
import Aboutpage from './Pages/Aboutpage';
import Footer from './Components/Footer';
import Header from './Components/Header';
import './App.css';

function App() {
  return (
    <div style={{backgroundColor: '#212121', minHeight: '100vh'}}>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutpage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
